import { CSS_VAR_TEXT } from '@common/constants';
import { CssStyleService } from '@common/services';
import { Chart } from 'chart.js';

export function noItemDisplayChart(baseChart: Chart, style: CssStyleService): void {
  if (!baseChart) {
    throw new Error('Caught error manually: The `noItemDisplayChart` method has been null or undefined');
  }

  const { datasets } = baseChart.data;
  const hasData = datasets.some((dataset) => {
    return dataset.data.length > 0 && !dataset.data.every((item) => item === 0);
  });

  if (!hasData) {
    const { ctx, width, height } = baseChart;

    baseChart.clear();
    ctx.save();
    ctx.fillStyle = style.cssVar(CSS_VAR_TEXT);
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('No Data to Display', width / 2, height / 2);
    ctx.restore();
  }
}
